import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'First Group Session Behaviour Goal',
    subLabel:
      'Let’s make a smart goal for this week! The theme of this month’s goal should be having a balanced meal (¼ plate lean proteins, ¼ plate whole grains/high-fibre starches, and ½ plate fibrous vegetables and/or fruit). This goal should be only a baby step more than what you are already doing!',
    field: 'wl1stSessionQ1',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'I will have a balanced',
          type: 'dropdown',
          name: 'wl1stSessionPt1',

          placeholder: '(meal time)',
          options: [
            { key: 'breakfast', value: 'breakfast' },
            { key: 'lunch', value: 'lunch' },
            { key: 'dinner', value: 'dinner' }
          ]
        },
        {
          label: 'at least times __ this week.',
          type: 'dropdown',
          name: 'wl1stSessionPt2',

          placeholder: '(number)',
          options: [
            { key: 'number1', value: '1' },
            { key: 'number2', value: '2' },
            { key: 'number3', value: '3' },
            { key: 'number4', value: '4' },
            { key: 'number5', value: '5' }
          ]
        }
      ]
    }
  },
  {
    field: 'wl1stSessionPtFinalMsg',
    type: 'info',
    educationalSlide:
      'Remember to try to revise this goal on a weekly basis until you next session by answering this consultation again!',
    label: '',
    answer: {}
  }
];
export default questionsModels;
